import { SignIn, SignUp } from "@clerk/react";

const Brand = () => (
  <div className="text-center lg:text-left space-y-3 fade-up">
    <div className="flex items-center gap-2 justify-center lg:justify-start">
      <span className="w-2.5 h-2.5 rounded-full bg-[#A9B26A] shadow-[0_0_12px_#636b2f]" />
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-slate-400">Jão · Turnê</span>
    </div>
    <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.9] text-white">
      Memórias<br /><span className="text-[#A9B26A]">Póstumas</span>
    </h1>
    <p className="text-slate-400 text-sm sm:text-base max-w-sm mx-auto lg:mx-0">Checklist de carregamento dos caminhões e guinchos da turnê.</p>
  </div>
);

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen hero-bg grid lg:grid-cols-2 items-center gap-10 px-4 py-10 max-w-6xl mx-auto" data-testid={`${mode}-page`}>
      <Brand />
      <div className="flex items-center justify-center">
        {mode === "sign-in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
